import React, { useEffect, useState } from "react";
import { Card, Row } from "antd";
import { useSelector } from "react-redux";
import DOMPurify from 'dompurify';

const FlightResultContent = () => {

    const { content } = useSelector((state) => state.flights);
    const [selectedCity, setSelectedCity] = useState('');
    const [selectedCityTo, setSelectedCityTo] = useState('');
    const [selectedCityFAQ, setSelectedCityFAQ] = useState('');

    useEffect(() => {
        if (content && Object.keys(content).length > 0) {
            setSelectedCity(Object.keys(content)[0]);
            setSelectedCityTo(Object.keys(content)[1]);
            setSelectedCityFAQ(Object.keys(content)[2]);
        }
    }, [content]);

    const cityContent = content?.[selectedCity] || {};
    const cityContentTo = content?.[selectedCityTo] || {};
    const cityContentFAQ = content?.[selectedCityFAQ] || {};

    const sanitizedDescription = DOMPurify.sanitize(cityContent?.destination_description || '');
    const sanitizedDescriptionTo = DOMPurify.sanitize(cityContentTo?.destination_description || '');
    const sanitizedDescriptionFAQ = DOMPurify.sanitize(cityContentFAQ?.description || '');

    return (
        <Row gutter={16} className="airport_content mt-5 mb-5 d-md-block d-none">

            {(cityContent?.city_name && cityContent?.destination_description) ||
                (cityContentTo?.city_name && cityContentTo?.destination_description) ? (
                <>
                    <Card>

                        {/* faq */}
                        {cityContentFAQ?.from_city_code && cityContentFAQ?.description && (
                            <>
                                <section id="To-City">
                                    <div>
                                        {/* <h2>{cityContentFAQ?.from_city} ({cityContentFAQ?.from_city_code}) {cityContentFAQ?.to_city}  {cityContentFAQ?.to_city_code}</h2> */}
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: sanitizedDescriptionFAQ,
                                            }}
                                        />
                                    </div>
                                </section>
                            </>
                        )}

                        {/* From City */}
                        {cityContent?.city_name && cityContent?.destination_description && (
                            <>
                                <hr className='my-4' />
                                <section id="From-City">
                                    <div>
                                        <h2>{cityContent?.city_name} ({cityContent?.airport_code}) {cityContent?.country_name}</h2>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: sanitizedDescription,
                                            }}
                                        />
                                    </div>
                                </section>
                            </>
                        )}

                        {/* To City */}
                        {cityContentTo?.city_name && cityContentTo?.destination_description && (
                            <>
                                <hr className='my-4' />
                                <section id="To-City">
                                    <div>
                                        <h2>{cityContentTo?.city_name} ({cityContentTo?.airport_code}) {cityContentTo?.country_name}</h2>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: sanitizedDescriptionTo,
                                            }}
                                        />
                                    </div>
                                </section>
                            </>
                        )}


                    </Card>
                </>
            ) : null}

        </Row>
    );
};

export default FlightResultContent;
